import { Controller } from "@hotwired/stimulus"

// Toggles between localized editor panes (pt / en) inside the post form.
// Each pane has `data-language-tabs-target="pane"` with `data-locale` set,
// each tab has `data-language-tabs-target="tab"` and triggers `switch`
// with a `locale` param.
export default class extends Controller {
  static targets = ["pane", "tab"]

  connect() {
    this.activate(this.initialLocale)
  }

  switch(event) {
    event.preventDefault()
    this.activate(event.params.locale)
  }

  activate(locale) {
    this.paneTargets.forEach(p => {
      p.hidden = p.dataset.locale !== locale
    })
    this.tabTargets.forEach(t => {
      const active = t.dataset.locale === locale
      t.classList.toggle("is-active", active)
      t.setAttribute("aria-selected", active)
    })
  }

  get initialLocale() {
    const active = this.tabTargets.find(t => t.classList.contains("is-active"))
    return active?.dataset?.locale || this.tabTargets[0]?.dataset?.locale || "pt"
  }
}
